(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cdp-featured-collections-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  var instances = new WeakMap();
  var editorTabs = new Map();
  var requestFrame = window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 16); };
  var cancelFrame = window.cancelAnimationFrame || window.clearTimeout;

  function initialiseTabs(section) {
    if (instances.has(section)) return;
    var tabs = Array.from(section.querySelectorAll('.fc-tab-btn'));
    var panels = Array.from(section.querySelectorAll('.fc-panel'));
    if (!tabs.length) return;
    var isEditor = section.dataset.fcEditor === 'true';
    var sectionId = section.dataset.sectionId;

    function reduceMotion() {
      var browserPreference = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var themePreference = document.querySelector('[data-disable-animations="true"]');
      return Boolean(browserPreference || themePreference);
    }

    function initialiseRail(rail) {
      var scroller = rail.querySelector('[data-fc-scroller]');
      var track = rail.querySelector('.fc-scroll-track');
      var previousButton = rail.querySelector('[data-fc-scroll-previous]');
      var nextButton = rail.querySelector('[data-fc-scroll-next]');
      if (!scroller || !track || !previousButton || !nextButton) return null;
      var helpId = scroller.getAttribute('aria-describedby');
      var frame = 0;

      function setButton(button, visible) {
        if (!visible && document.activeElement === button) {
          try { scroller.focus({ preventScroll: true }); }
          catch (error) { scroller.focus(); }
        }
        button.disabled = !visible;
        button.hidden = !visible;
      }

      function update() {
        frame = 0;
        var maximum = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        var position = Math.min(maximum, Math.abs(scroller.scrollLeft));
        var desktop = !window.matchMedia || window.matchMedia('(min-width: 769px)').matches;
        var hasOverflow = maximum > 2;
        var canScrollPrevious = hasOverflow && position > 2;
        var canScrollNext = hasOverflow && position < maximum - 2;
        scroller.tabIndex = hasOverflow ? 0 : -1;
        if (hasOverflow && helpId) scroller.setAttribute('aria-describedby', helpId);
        else scroller.removeAttribute('aria-describedby');
        rail.dataset.canScrollPrevious = String(canScrollPrevious);
        rail.dataset.canScrollNext = String(canScrollNext);
        setButton(previousButton, desktop && canScrollPrevious);
        setButton(nextButton, desktop && canScrollNext);
      }

      function queueUpdate() {
        if (frame) return;
        frame = requestFrame(update);
      }

      function scrollByPage(direction) {
        var item = track.querySelector('.fc-scroll-item:not(.fc-scroll-empty)');
        var cardWidth = item ? item.getBoundingClientRect().width : 250;
        if (!cardWidth) cardWidth = 250;
        var amount = Math.max(cardWidth, scroller.clientWidth - cardWidth);
        var rtl = getComputedStyle(scroller).direction === 'rtl';
        var left = direction * amount * (rtl ? -1 : 1);
        if (typeof scroller.scrollBy === 'function') {
          scroller.scrollBy({ left: left, behavior: reduceMotion() ? 'auto' : 'smooth' });
        } else {
          scroller.scrollLeft += left;
          queueUpdate();
        }
      }

      function onPrevious() { scrollByPage(-1); }
      function onNext() { scrollByPage(1); }
      scroller.addEventListener('scroll', queueUpdate, { passive: true });
      previousButton.addEventListener('click', onPrevious);
      nextButton.addEventListener('click', onNext);
      window.addEventListener('resize', queueUpdate, { passive: true });
      var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(queueUpdate) : null;
      if (observer) {
        observer.observe(scroller);
        observer.observe(track);
      }
      queueUpdate();

      return {
        rail: rail,
        queueUpdate: queueUpdate,
        destroy: function () {
          if (frame) cancelFrame(frame);
          scroller.removeEventListener('scroll', queueUpdate);
          previousButton.removeEventListener('click', onPrevious);
          nextButton.removeEventListener('click', onNext);
          window.removeEventListener('resize', queueUpdate);
          if (observer) observer.disconnect();
        }
      };
    }

    var railControllers = Array.from(section.querySelectorAll('[data-fc-rail]')).map(initialiseRail).filter(Boolean);

    function refreshPanelRails(panel) {
      requestFrame(function () {
        railControllers.forEach(function (controller) {
          if (panel.contains(controller.rail)) controller.queueUpdate();
        });
      });
    }

    var nav = section.querySelector('.fc-tab-nav');
    var indicator = nav ? nav.querySelector('.fc-tab-indicator') : null;
    var wrapper = section.querySelector('.fc-panels-wrapper');
    var switchState = null;
    var revealObserver = null;
    var revealTimer = 0;
    var navObserver = null;

    function activeTab() {
      return tabs.find(function (item) { return item.classList.contains('fc-tab-btn--active'); }) || tabs[0];
    }

    function moveIndicator(tab, instant) {
      if (!indicator || !tab || !nav.classList.contains('fc-tab-nav--pill')) return;
      if (instant) nav.classList.remove('fc-tab-nav--ready');
      nav.style.setProperty('--fc-pill-x', tab.offsetLeft + 'px');
      nav.style.setProperty('--fc-pill-y', tab.offsetTop + 'px');
      nav.style.setProperty('--fc-pill-w', tab.offsetWidth + 'px');
      nav.style.setProperty('--fc-pill-h', tab.offsetHeight + 'px');
      if (instant) {
        requestFrame(function () {
          requestFrame(function () { nav.classList.add('fc-tab-nav--ready'); });
        });
      }
    }

    function onNavResize() { moveIndicator(activeTab(), true); }

    function setDelays(panel, base, step) {
      var scroller = panel.querySelector('[data-fc-scroller]');
      var bounds = scroller ? scroller.getBoundingClientRect() : null;
      var order = 0;
      Array.from(panel.querySelectorAll('.fc-scroll-item')).forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var visible = !bounds || (rect.right > bounds.left + 1 && rect.left < bounds.right - 1);
        item.style.setProperty('--fc-delay', (base + Math.min(order, 7) * step) + 'ms');
        if (visible) order += 1;
      });
    }

    function clearDelays(panel) {
      Array.from(panel.querySelectorAll('.fc-scroll-item')).forEach(function (item) {
        item.style.removeProperty('--fc-delay');
      });
    }

    function finishSwitch() {
      if (!switchState) return;
      var state = switchState;
      switchState = null;
      window.clearTimeout(state.timer);
      state.from.hidden = true;
      state.from.classList.remove('fc-panel--leaving', 'fc-panel--fade', 'fc-panel--active');
      state.from.removeAttribute('aria-hidden');
      state.to.classList.remove('fc-panel--entering');
      clearDelays(state.to);
      if (wrapper) {
        wrapper.classList.remove('fc-panels--switching');
        wrapper.style.height = '';
      }
    }

    function startSwitch(fromPanel, toPanel) {
      var startHeight = wrapper.offsetHeight;
      wrapper.style.height = startHeight + 'px';
      wrapper.classList.add('fc-panels--switching');
      fromPanel.classList.remove('fc-panel--active');
      fromPanel.classList.add('fc-panel--leaving');
      fromPanel.setAttribute('aria-hidden', 'true');
      toPanel.hidden = false;
      toPanel.classList.add('fc-panel--active');
      setDelays(toPanel, 150, 70);
      toPanel.classList.add('fc-panel--entering');
      var endHeight = toPanel.offsetHeight;
      var state = { from: fromPanel, to: toPanel, timer: 0 };
      switchState = state;
      requestFrame(function () {
        requestFrame(function () {
          if (switchState !== state) return;
          fromPanel.classList.add('fc-panel--fade');
          wrapper.style.height = endHeight + 'px';
        });
      });
      state.timer = window.setTimeout(finishSwitch, 150 + 70 * 7 + 900 + 60);
    }

    function playReveal() {
      var panel = panels.find(function (item) { return item.classList.contains('fc-panel--active'); });
      if (panel) setDelays(panel, 120, 110);
      section.classList.add('fc-reveal-play');
      section.classList.remove('fc-reveal-pending');
      revealTimer = window.setTimeout(function () {
        revealTimer = 0;
        section.classList.remove('fc-reveal-play');
        if (panel && !panel.classList.contains('fc-panel--entering')) clearDelays(panel);
      }, 120 + 110 * 7 + 900 + 100);
    }

    function setupReveal() {
      var pending = section.classList.contains('fc-reveal-pending');
      if (isEditor || reduceMotion() || typeof IntersectionObserver !== 'function') {
        section.classList.remove('fc-reveal-pending');
        return;
      }
      section.dataset.fcMotion = 'ready';
      if (!pending) {
        var rect = section.getBoundingClientRect();
        var viewport = window.innerHeight || document.documentElement.clientHeight;
        if (rect.top < viewport && rect.bottom > 0) return;
        section.classList.add('fc-reveal-pending');
      }
      revealObserver = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        revealObserver.disconnect();
        revealObserver = null;
        playReveal();
      }, { threshold: 0.2 });
      revealObserver.observe(section);
    }

    function initMotion() {
      if (indicator) {
        nav.classList.add('fc-tab-nav--pill');
        moveIndicator(activeTab(), true);
        if (typeof ResizeObserver === 'function') {
          navObserver = new ResizeObserver(onNavResize);
          navObserver.observe(nav);
        } else {
          window.addEventListener('resize', onNavResize, { passive: true });
        }
      }
      setupReveal();
    }

    function cleanupMotion() {
      finishSwitch();
      if (revealObserver) revealObserver.disconnect();
      revealObserver = null;
      if (revealTimer) window.clearTimeout(revealTimer);
      section.classList.remove('fc-reveal-pending', 'fc-reveal-play');
      if (navObserver) navObserver.disconnect();
      else window.removeEventListener('resize', onNavResize);
      if (nav) nav.classList.remove('fc-tab-nav--pill', 'fc-tab-nav--ready');
    }

    function activateTab(tab, moveFocus, instant) {
      var targetPanel = panels.find(function (panel) { return panel.id === tab.getAttribute('aria-controls'); });
      if (!targetPanel) return;
      finishSwitch();
      var currentPanel = panels.find(function (panel) { return panel.classList.contains('fc-panel--active'); });
      tabs.forEach(function (item) {
        var selected = item === tab;
        item.classList.toggle('fc-tab-btn--active', selected);
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      moveIndicator(tab, Boolean(instant || isEditor));
      var animate = !instant && !isEditor && !reduceMotion() && wrapper && currentPanel && currentPanel !== targetPanel;
      if (animate) {
        startSwitch(currentPanel, targetPanel);
      } else {
        panels.forEach(function (panel) {
          var selected = panel === targetPanel;
          panel.hidden = !selected;
          panel.classList.toggle('fc-panel--active', selected);
        });
      }
      refreshPanelRails(targetPanel);
      if (isEditor) editorTabs.set(sectionId, tab.dataset.tabNumber);
      if (moveFocus) tab.focus();
    }

    function eventTab(event) {
      if (!(event.target instanceof Element)) return null;
      var tab = event.target.closest('.fc-tab-btn');
      return tabs.indexOf(tab) !== -1 ? tab : null;
    }
    function onClick(event) {
      var tab = eventTab(event);
      if (tab) activateTab(tab, false);
    }
    function onKeydown(event) {
      var tab = eventTab(event);
      if (!tab || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      var index = tabs.indexOf(tab);
      var nextIndex;
      var rtl = getComputedStyle(section).direction === 'rtl';
      switch (event.key) {
        case 'ArrowRight': nextIndex = index + (rtl ? -1 : 1); break;
        case 'ArrowLeft': nextIndex = index + (rtl ? 1 : -1); break;
        case 'Home': nextIndex = 0; break;
        case 'End': nextIndex = tabs.length - 1; break;
        default: return;
      }
      event.preventDefault();
      activateTab(tabs[(nextIndex + tabs.length) % tabs.length], true);
    }
    function onBlockSelect(event) {
      if (!isEditor) return;
      var blockId = event.detail && event.detail.blockId;
      var block = Array.from(section.querySelectorAll('[data-fc-block-id]')).find(function (item) {
        return item.dataset.fcBlockId === blockId;
      });
      if (!block && event.target instanceof Element) block = event.target.closest('[data-fc-block-id]');
      if (!block || !section.contains(block)) return;
      var panel = block.closest('.fc-panel');
      if (!panel) return;
      var tab = tabs.find(function (item) { return item.getAttribute('aria-controls') === panel.id; });
      if (tab) {
        activateTab(tab, false);
        block.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
      }
    }
    section.addEventListener('click', onClick);
    section.addEventListener('keydown', onKeydown);
    section.addEventListener('shopify:block:select', onBlockSelect);
    instances.set(section, function () {
      railControllers.forEach(function (controller) { controller.destroy(); });
      cleanupMotion();
      section.removeEventListener('click', onClick);
      section.removeEventListener('keydown', onKeydown);
      section.removeEventListener('shopify:block:select', onBlockSelect);
      instances.delete(section);
    });
    initMotion();
    if (isEditor) {
      var previous = tabs.find(function (tab) { return tab.dataset.tabNumber === editorTabs.get(sectionId); });
      if (previous) activateTab(previous, false);
    }
  }
  function forEachSection(root, callback) {
    if (root.matches && root.matches('.fc-tabs-section[data-fc-version="7"]')) callback(root);
    root.querySelectorAll('.fc-tabs-section[data-fc-version="7"]').forEach(callback);
  }
  function initialiseWithin(root) { forEachSection(root, initialiseTabs); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseWithin(document); }, { once: true });
  } else { initialiseWithin(document); }
  document.addEventListener('shopify:section:load', function (event) { initialiseWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    forEachSection(event.target, function (section) {
      var destroy = instances.get(section);
      if (destroy) destroy();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
